import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=552ac52f&scoped=true"
import script from "./Column.vue?vue&type=script&lang=ts"
export * from "./Column.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Column.vue?vue&type=style&index=0&id=552ac52f&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "552ac52f",
  "1d107e64"
  
)

export default component.exports